define('modules/accounts/status/products/mdirector/balance/transfer/index',['require','exports','module','./model','./form/view','./resume/view'],function(require, exports, module) {
    "use strict";

    module.exports = {
        TransferModel: require("./model"),
        TransferFormView: require("./form/view"),
        TransferResumeView: require("./resume/view")
    };
});

